import { render, staticRenderFns } from "./EditNewsPage.vue?vue&type=template&id=e5567d7c&"
import script from "./EditNewsPage.vue?vue&type=script&lang=js&"
export * from "./EditNewsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports